import React from "react";

import { CircularProgress, Typography } from "@material-ui/core";

import { Container } from "./styles";

const LoadingFile = () => (
  <>
    <Container>
      <CircularProgress color="primary" size={24} />
      <Typography
        variant="body2"
        style={{
          marginLeft: "10px",
          alignContent: "center",
        }}
      >
        Uploading File...please wait
      </Typography>
    </Container>
  </>
);

export default LoadingFile;
